/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

const EaseeView = ({ locale, hotelConfig: { awsApiGatewayInvokeUrl, hotelId, bundleId } }) => {
  const [link, setLink] = useState();
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const actionToGo = query.get("action");

  const getToken = async () => {
    const AuthData = await Auth.currentAuthenticatedUser();
    return AuthData.signInUserSession.getRefreshToken().token;
  };

  useEffect(() => {
    getToken().then(token => {
      const random = Math.random();
      const baseLink =
        awsApiGatewayInvokeUrl === "https://dev.getwebee.com"
          ? `https://easee-test.webee.app?lang=${locale}&refresh_token=${token}&bundle=${bundleId}&hotel_id=${hotelId}`
          : `https://easee.webee.app?lang=${locale}&refresh_token=${token}&bundle=${bundleId}&hotel_id=${hotelId}`;
      setLink(`${baseLink}&random=${random}${actionToGo && `&actionToGo=${actionToGo}`}`);
    });
  }, [locale, awsApiGatewayInvokeUrl, hotelId, hotelId, bundleId, actionToGo]);

  useEffect(() => {
    document.body.classList.add("no-overflow");
    setTimeout(() => {
      if (document.getElementById("easeeFrame")) {
        document.getElementById("easeeFrame").style.height = `${window.innerHeight - 70}px`;
      } else {
        console.warn("delay not enough for frame");
      }
    }, 250);

    const onResize = () => {
      if (document.getElementById("easeeFrame")) {
        document.getElementById("easeeFrame").style.height = `${window.innerHeight - 70}px`;
      } else {
        console.warn("easeeFrame not found this is not normal");
      }
    };

    window.addEventListener("resize", onResize);
    return () => {
      document.body.classList.remove("no-overflow");
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <div id="easeeFrame" className="easeeIframe">
      {link && <iframe title="easee" src={link} width="100%" height="100%" style={{ border: 0, overflow: "hidden" }} allow="autoplay" />}
    </div>
  );
};

const mapStateToProps = ({ settings }) => {
  const { locale, hotelConfig } = settings;
  return { locale, hotelConfig };
};

export default connect(mapStateToProps)(EaseeView);
